import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-benchmark-popover',
  templateUrl: './benchmark-popover.component.html',
  styleUrls: ['./benchmark-popover.component.css']
})
export class BenchmarkPopoverComponent implements OnInit {
  @Input() userBenchmark;
  @Output()
  accessClick: EventEmitter<String> = new EventEmitter<String>();
  constructor() { }

  ngOnInit() {

  }
  selectedAccess(event, accessType){
    this.accessClick.emit(accessType);
  }


}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/benchmark-popover/benchmark-popover.component.ts